import Vue from 'vue'
import App from './App.vue'
import router from './router'
import http from './common/request'
Vue.config.productionTip = false
Vue.prototype.$http = http
// eruda.init()
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
